import { createContext } from "react";

const loaderContext = createContext();

export default loaderContext;